import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IProduct } from '../../models/products.models';
import { environment } from 'src/environments/environment';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-details-dialogue-product',
  templateUrl: './details-dialogue-product.component.html',
  styleUrls: ['./details-dialogue-product.component.scss']
})
export class DetailsDialogueProductComponent implements OnInit {
  product!: IProduct;
  currentImage = 0;
  allImages: string[] = [];
  isDescriptionExpanded = false;
  shouldShowToggle = false;
  hasDescription = false;
  isVariant = false;
  @ViewChild('descriptionText') descriptionText!: ElementRef<HTMLDivElement>;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IProduct,
    private dialogRef: MatDialogRef<DetailsDialogueProductComponent>,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.product = {...this.data};
      const mainImage = this.product.image ? [this.product.image] : [];
      const extraImages = Array.isArray(this.product.images) ? this.product.images : [];

      this.allImages = [...mainImage, ...extraImages].map((img: string | { url?: string }) => this.getImageUrl(img));
      this.product.image = this.allImages[0] || 'assets/images/no-img.svg';
      this.currentImage = 0;

      this.hasDescription = !!this.product?.description?.trim();

      if (this.product.variants && this.product.variants.length > 1) {
        this.isVariant = true;
      }
    }
  }

  getImageUrl(path: string | { url?: string }): string {
    if (!path) return 'assets/images/no-img.svg';
    const url = typeof path === 'string' ? path : path.url || '';
    if (!url) return 'assets/images/no-img.svg';
    if (url.startsWith('cdn/')) return environment.BASE_URL_API + '/' + url;
    return url;
  }

  selectImage(index: number) {
    if (!this.allImages?.length) return;
    this.currentImage = index;
    this.product.image = this.allImages[index];
  }

  prevImage() {
    if (!this.allImages?.length) return;
    this.currentImage = (this.currentImage - 1 + this.allImages.length) % this.allImages.length;
    this.product.image = this.allImages[this.currentImage];
  }

  nextImage() {
    if (!this.allImages?.length) return;
    this.currentImage = (this.currentImage + 1) % this.allImages.length;
    this.product.image = this.allImages[this.currentImage];
  }

  getCurrencySymbol(): string {
    return (
      this.product?.default_currency?.symbol ||
      this.product?.catalogs?.[0]?.default_currency?.symbol ||
      '€'
    );
  }

  toggleDescription(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.descriptionText) {
        const el = this.descriptionText.nativeElement;
        this.shouldShowToggle = el.scrollHeight > el.clientHeight;
      }
    }, 100);
  }

  cancel() {
    this.dialogRef.close();
  }
}
